import { get } from 'lodash';
import { useState } from 'react';
import {
  FieldProps,
  RaRecord,
  useAuthProvider,
  useDataProvider,
  useRecordContext,
} from 'react-admin';
import { useLocation } from 'react-router-dom';

import { Button } from '@sh4res/bo-common/components';

import { STORAGE_KEYS } from '@Utils/storage_keys';

export const GhostLinkField = (_props: FieldProps) => {
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const record = useRecordContext<RaRecord>();
  const authProvider = useAuthProvider();
  const dataProvider = useDataProvider();

  if (!record || get(record, 'status') !== 'active') {
    return null;
  }

  const resourcePath = 'admins/login_link';
  return (
    <Button
      data-testid={'BoExternalGhostLinkField_GhostLoginButton'}
      permissions={{
        resource: resourcePath,
        action: 'show',
      }}
      size="small"
      label={'resources.admins.fields.ghost_login'}
      disabled={loading}
      onClick={async (event) => {
        event.stopPropagation();
        setLoading(true);
        await dataProvider.getOne(resourcePath, {
          id: get(record, 'id') as number,
        });
        setLoading(false);
        authProvider.resetCache();
        sessionStorage.setItem(
          STORAGE_KEYS.preImpersonationNavState,
          `${location.pathname}${location.search}`,
        );
        window.location.replace('/');
      }}
    />
  );
};
